/** @jsxImportSource @emotion/react */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Navigation, PostTemplate } from 'ui';
import apis from 'apis';

const Notice = () => {
  const params = useParams();
  const [post, setPost] = useState();

  useEffect(() => {
    apis.movements.getOnce(params.id).then((data) => {
      setPost(data);
    });
  }, [params.id]);

  return (
    <>
      <Navigation />

      <PostTemplate
        type="movements"
        id={post?.id}
        likeCount={post?.like_count}
        title={post?.title}
        date={post?.created_at}
        body={`${post?.body_public}`}
        images={post?.images}
      />
    </>
  );
};

export default Notice;
